import { z } from "zod";
var InAppNotificationType = /* @__PURE__ */ ((InAppNotificationType2) => {
  InAppNotificationType2["UsageAlert"] = "USAGE_ALERT";
  InAppNotificationType2["ErrorAlert"] = "ERROR_ALERT";
  return InAppNotificationType2;
})(InAppNotificationType || {});
const InAppNotification = z.object({
  id: z.number(),
  userId: z.number(),
  teamId: z.number(),
  alertId: z.number().optional(),
  triggeredAt: z.string().datetime(),
  type: z.nativeEnum(InAppNotificationType),
  body: z.string(),
  read: z.boolean()
});
export {
  InAppNotification,
  InAppNotificationType
};
//# sourceMappingURL=inAppNotifications.js.map